import { jsx as _jsx } from "react/jsx-runtime";
import { CustomButton } from "./styled";
export const Button = ({ onClick, width, disabled = false, secondary, style, children, loading, ...styled }) => (_jsx(CustomButton, { disabled: disabled, onClick: onClick, width: width, secondary: secondary, style: style, loading: loading, ...styled, children: children }));
